
import Vue from "vue";
import { NewTenantUsersApiFunc, setAccessToken } from "@/api";
import { TenantUser } from "@/models";

import TenantUserList from "./components/TenantUserList.vue";
import SearchForm from "@/components/BaseSearchForm.vue";
import Pager from "@/components/BasePager.vue";
import TheTemplate from "../TheTemplate.vue";

export type FilterCondition = {
  word?: string;
};

export type DataType = {
  tenantUsers: Array<TenantUser>;
  filterCondition: FilterCondition;
  totalPage: number;
  currentPage: number;
};

export default Vue.extend({
  name: "TenantUserListScreen",

  data(): DataType {
    return {
      tenantUsers: [],
      filterCondition: {
        word: "",
      },
      totalPage: 0,
      currentPage: 0,
    };
  },

  mounted() {
    this.fetchTenantUsers();
  },

  watch: {
    $route(to, from) {
      if (to.params.updated === "true") {
        this.fetchTenantUsers(this.currentPage);
      }
    },
  },

  components: {
    TheTemplate,
    SearchForm,
    TenantUserList,
    Pager,
  },

  methods: {
    async fetchTenantUsers(page?: number): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const filterString: string = JSON.stringify({
        q: this.filterCondition.word,
      });
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewTenantUsersApiFunc().listTenantUsers(
        companyId,
        filterString,
        page
      );
      if (err != null) {
        this.$handleApiError(err, () => {
          this.fetchTenantUsers(page);
        });
        return;
      }

      this.tenantUsers = data.list;
      this.currentPage = data.currentPage;
      this.totalPage = data.totalPage;
    },

    changePage(page: number): void {
      this.fetchTenantUsers(page);
    },
  },
});
